import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import {
  createAuthorizationHeader,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";
import { Comment, CreateComment } from "../types/Comment";

const BASE_URL = `${TASKS_SERVICE_URL}/comments`;

export async function createComment(createComment: CreateComment) {
  return toJson<Comment>(
    await fetch(BASE_URL, {
      method: "POST",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createComment),
    })
  );
}
